import { Form as UnformForm } from '@unform/web'
import styled from 'styled-components'

import { FormGroup } from '~/components/unform'

export const RejectForm = styled(UnformForm)`
  min-height: 0;
`

export const RejectFields = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 0;
  padding: 0 1rem 1rem;
`

export const RejectFormGroup = styled(FormGroup)`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;

  label {
    margin-top: 4px;
    margin-bottom: 0;
  }
  small {
    margin-bottom: 8px;
    margin-top: 4px;
  }

  .inputContainer {
    align-items: stretch;

    textarea {
      min-height: 7rem;
      height: 7rem;
      resize: none;
    }
  }
`

export const RejectFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  width: 100%;
  margin-top: 1.5rem;

  button[type='submit'] {
    min-height: auto;
    min-width: auto;
  }
`
